import React from "react";
import { Box, Typography, Container, Grid2, Card, CardContent, CardMedia } from "@mui/material";
import { Helmet } from "react-helmet";
import { useTheme } from "@mui/material/styles";
import Invitation from "../assets/Invitation.jpg";
import Christmas from "../assets/christmas.jpg";
import NewYear from "../assets/newyear.jpg";
import Easter from "../assets/church_service.jpg";
import Youth from "../assets/youthcamp.jpg";
import AnbinVirudhu from "../assets/anbin_virunthu.png";

const Events = () => {
  const theme = useTheme();

  const events = [
    {
      date: "September 28, 2025",
      title: "Harvest Festival",
      description:
        "Join us for our Harvest Festival as we thank God for His abundant blessings with songs, offerings, and a joyful fellowship meal.",
      image: AnbinVirudhu,
    },
    {
      date: "October 19, 2025",
      title: "Youth Revival Meeting",
      description:
        "An inspiring youth gathering filled with worship, testimonies, and powerful messages to strengthen the next generation in faith.",
      image: Youth,
    },
    {
      date: "December 21, 2025",
      title: "Anbin Virudhu - Loving Feast",
      description:
        "Sunday class children present dances, skits, and performances reflecting their growth throughout the year. The event concludes with a loving feast of fellowship.",
      image: AnbinVirudhu,
    },
    {
      date: "December 25, 2025",
      title: "Christmas Celebration",
      description:
        "Celebrate the birth of Christ with special services, carols, and fellowship. A joyful gathering for the whole community!",
      image: Christmas,
    },
    {
      date: "January 1, 2026",
      title: "New Year Celebration",
      description:
        "Begin the New Year with midnight worship, thanksgiving prayers, and a special message of hope for 2026.",
      image: NewYear,
    },
    {
      date: "April 5, 2026",
      title: "Easter Celebration",
      description:
        "Rejoice in the resurrection of Jesus with uplifting worship, communion, and inspirational preaching.",
      image: Easter,
    },

  ];

  return (
    <Box
      sx={{
        py: 5,
        backgroundColor: "background.default",
        animation: `${theme.keyframes.fadeIn} 1.5s`,
      }}
    >
      {/* SEO Metadata */}
      <Helmet>
        <title>Events | Praise Revival Church Dharmapuri</title>
      </Helmet>

      <Container>
        {/* Page Title */}
        <Typography
          variant="h2"
          gutterBottom
          align="center"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            animation: `${theme.keyframes.fadeInUp} 1.5s`,
          }}
        >
          Upcoming Events
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 4,
            fontSize: "1.2rem",
            color: "text.secondary",
            animation: `${theme.keyframes.fadeInUp} 2s`,
          }}
        >
          Stay updated on the latest events and programs happening at Praise Revival Church.
        </Typography>

        {/* Events Grid */}
        <Grid2 container spacing={4}>
          {events.map((event, index) => (
            <Grid2
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{
                animation: `${theme.keyframes.zoomIn} 2s`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: "350px",
                  boxShadow: theme.shadows[3],
                  borderRadius: 2,
                  overflow: "hidden",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: theme.shadows[5],
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={event.image}
                  alt={`${event.title} Image`}
                />
                <CardContent sx={{ backgroundColor: "background.paper" }}>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: "bold", color: "primary.main" }}
                  >
                    {event.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ mb: 2, color: "text.primary" }}
                  >
                    {event.description}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontStyle: "italic",
                      color: "secondary.main",
                    }}
                  >
                    {event.date}
                  </Typography>
                </CardContent>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Container>
    </Box>
  );
};

export default Events;
